import BlockCarouselItemData from './BlockCarouselItemData';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import { BlockHeight } from '../../../models/BlockSettings';

class BlockCarouselData {
  carousel: BlockCarouselItemData[];
  auto: boolean;
  autoInterval?: number;
  height?: BlockHeight;
  url?: BlockComponentImage;
  fixedAspectRatio?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockCarouselData {
  export function make(
    carousel: BlockCarouselItemData[],
    auto: boolean,
    autoInterval: number,
    height: BlockHeight,
    url?: string,
    fixedAspectRatio?: boolean,
  ): BlockCarouselData {
    return {
      carousel,
      auto,
      autoInterval,
      height,
      url: BlockComponentImage.make(url),
      fixedAspectRatio,
    };
  }

  export function getDefault(
    src = '',
    height = BlockHeight.NORMAL,
    auto = false,
    autoInterval = 6,
    fixedAspectRatio = false,
  ): BlockCarouselData {
    return make(
      [
        BlockCarouselItemData.getDefault(src),
        BlockCarouselItemData.getDefault(src),
        BlockCarouselItemData.getDefault(src),
        BlockCarouselItemData.getDefault(src),
      ],
      auto,
      autoInterval,
      height,
      src,
      fixedAspectRatio,
    );
  }
}

export default BlockCarouselData;
